/*
 * @Author: Src
 * @Date: 2025-10-10 13:50:04
 * @LastEditTime: 2025-10-30 10:13:22
 * @LastEditors: Src
 * @FilePath: /work-station/src/components/UnsaveGuardMixin.ts
 * @Description: 未保存更改拦截器混合类，用于在离开页面或路由时提示用户是否有未保存的更改。
 */
import { Component, Vue } from 'vue-property-decorator';


@Component({
  beforeRouteLeave(to: any, from: any, next: any) {
    // 判断是否有未保存的数据
    console.log('即将离开页面，检查是否有未保存的更改...');
    if ((this as any).hasUnsavedData()) {
      const answer = window.confirm('你有未保存的更改，确定要离开吗？');
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
})
export default class UnsaveGuardMixin extends Vue {
  // 是否有未保存的更改
  protected hasUnsavedChanges = false;

  private hasUnsavedData(): boolean {
    // 你的判断逻辑，比如表单是否被修改
    return this.hasUnsavedChanges;
  }

  created() {
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  }

  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  }

  // 处理页面卸载前的拦截
  protected handleBeforeUnload(e: BeforeUnloadEvent) {
    if (this.hasUnsavedChanges) {
      e.preventDefault();
      // Chrome 需要设置 returnValue
      e.returnValue = this.getUnsavedMessage();
      return e.returnValue;
    }
  }

  // 路由离开守卫
  protected beforeRouteLeave(to: any, from: any, next: any) {
    if (this.hasUnsavedChanges) {
      if (confirm(this.getUnsavedMessage())) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }

  // 可重写的提示消息
  protected getUnsavedMessage(): string {
    return '您有未保存的更改，确定要离开吗？';
  }
}
